<div class="inner">
	<div class="img">
		<img [src]="image(miscModel)" />
	</div>

	@if (miscModel.Description) {
	<div class="title">
		<h6><b>{{miscModel.Description}}</b></h6>
	</div>
	}
	@if (miscModel.EcommerceNoUnique) {
	<div class="description">
		<div>{{miscModel.EcommerceNoUnique}}</div>
	</div>
	}

	@if (miscModel.StockKeepingUnitExtendedTexts && miscModel.StockKeepingUnitExtendedTexts.length) {
	<div class="description">
		@for (text of miscModel.StockKeepingUnitExtendedTexts; track text) {
		<div>{{text?.Text}}</div>
		}
	</div>
	}

</div>
@if (selected && showOverlay) {
<menu-overlay [mainOverlayText]="null" [secondOverlayText]="'CUSTOMIZER.CHANGES.BAGUPDATED' | translate" (overlayClicked)="null">
</menu-overlay>
}